import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { hooks } from '@febos-io/common';
import { utils } from '@febos-io/design';

import { resetPassword } from '../config';
import useTranslation from './useTranslation';
import { useAuthContext } from '../providers';

export function useResetPassword() {
  const navigate = useNavigate();
  const { t, } = useTranslation();
  const { signInPathname, renewPasswordPathname, } = useAuthContext();

  const {
    callback: onSubmit,
    loading,
  } = hooks.useRequestCallback(
    useCallback(async (request, { email, }) => {
      // El backend inyecta el passwordCode sobre esta URL base para armar el
      // enlace final (`<link>?passwordCode=<code>`) que recibe el usuario.
      const origin = typeof window === 'undefined' ? '' : window.location.origin;
      const link = `${origin}${renewPasswordPathname}`;
      const response = await request.exec(resetPassword(
        email,
        link
      ));
      if (response.code === 10) {
        utils.success(t('Instructions Sent Successfully'));
        navigate(signInPathname);
      } else {
        utils.error(t('Something went wrong'));
      }
    }, [navigate, signInPathname, renewPasswordPathname, t])
  );

  return {
    loading,
    onSubmit,
  };
}
